import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { fetchGroupedUnreadConversations } from 'modules/messenger/reducers/unreadMessages';

import { UNREAD_CHATS_POLLING_INTERVAL } from 'utils/messenger';

type Props = {
  dispatch: any,
  organizationId: number
};

type State = {
  timeoutId: number | null
};

class UnreadNotificationsChecker extends PureComponent<Props, State> {
  state: State = {
    timeoutId: null // eslint-disable-line react/no-unused-state
  };

  componentDidMount() {
    this.nextIteration();
  }

  componentWillUnmount() {
    if (window.app.env.FEATURE_UNREAD_MESSAGES_POLLING) {
      window.clearTimeout(this.state.timeoutId ?? -1);
    }
  }

  nextIteration = () => {
    const { dispatch, organizationId } = this.props;

    if (!document.hidden) {
      dispatch(fetchGroupedUnreadConversations(organizationId));
    }

    if (window.app.env.FEATURE_UNREAD_MESSAGES_POLLING) {
      const timeoutId = window.setTimeout(this.nextIteration, UNREAD_CHATS_POLLING_INTERVAL);
      this.setState({ timeoutId });
    }
  };

  render() {
    return null;
  }
}

export default connect()(UnreadNotificationsChecker);
